.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.notice {
  align-items: center;
  display: flex;
  gap: 8px;
  margin: 0;
}

.notice-icon {
  color: var(--color-text-muted, #666b76);
  flex-shrink: 0;
}

.body,
.body-plain {
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #e2e4e9);
  border-radius: 8px;
  color: var(--color-text, #17191d);
  font-size: 14px;
  line-height: 1.7;
  padding: 16px 18px;

  // Rates, closure dates and booking conditions are written as separate lines;
  // losing them turns the notes into an unscannable block.
  p {
    margin: 0 0 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 0 0 10px;
    padding-left: 20px;
  }

  a {
    color: var(--color-primary, #2563eb);
  }
}

// Plain-text notes: the source newlines ARE the formatting.
.body-plain {
  white-space: pre-line;
}
